import axios from "axios";
import { getMemberToken } from "@/context/MemberAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const t = getMemberToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
const d = (p) => p.then((r) => r.data);

export const memberApi = {
  me: () => d(client.get("/member/me")),
  updateProfile: (data) => d(client.put("/member/profile", data)),
  district: (slug) => d(client.get(`/member/districts/${slug}`)),
  paymentRequests: () => d(client.get("/member/payment-requests")),
  receipts: () => d(client.get("/member/receipts")),
  receipt: (id) => d(client.get(`/member/receipts/${id}`)),
  paymentsConfig: () => d(client.get("/payments/config")),
  createOrder: (rid) => d(client.post(`/member/payment-requests/${rid}/order`)),
  verifyPayment: (data) => d(client.post("/member/payments/verify", data)),
  createCombinedOrder: (requestIds) => d(client.post(`/member/payment-requests/combined-order`, { request_ids: requestIds })),
  verifyCombinedPayment: (data) => d(client.post("/member/payments/combined-verify", data)),
  receiptPdf: (id) => client.get(`/member/receipts/${id}/pdf`, { responseType: "blob" }).then((r) => r.data),
  uploadPhoto: (file) => { const fd = new FormData(); fd.append("file", file); return d(client.post("/member/profile/photo", fd)); },
  guideUrl: () => `${API}/guides/member`,
  getService: () => d(client.get("/member/service")),
  putService: (data) => d(client.put("/member/service", data)),
  requestCorrection: (note) => d(client.post("/member/service/request-correction", { note })),
  grs: () => d(client.get("/member/grs")),
  openGr: (id) => d(client.post(`/member/grs/${id}/open`)),
  downloadGr: (id) => d(client.post(`/member/grs/${id}/download`)),
  letters: () => d(client.get("/member/letters")),
  markLetterRead: (deliveryId) => d(client.post(`/member/letters/${deliveryId}/read`)),
  letterFileBlob: (letterId) => client.get(`/member/letters/${letterId}/file`, { responseType: "blob" }).then((r) => r.data),
};

export const requestAccess = (data) => d(axios.post(`${API}/access-requests`, data));
